<template>
  <div class="gltf-row" v-loading="loading" element-loading-background="rgba(11,39,64,0)">
    <div class="scene" ref="scene" style="height: 100%; width: 100%"></div>
  </div>
</template>

<script>
import * as THREE from "three"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
// 导入轨道模型控制器
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"
import { initDataBase, get } from '@/utils/indexedDB.js'
export default {
  data() {
    return {
      container: "", // 获取canvs画布对象
      scene: null, // 场景对象
      camera: null, // 照相机
      width: null, // 相机高度
      height: null,
      renderer: null, // 渲染器
      controls: null,
      light: null, // 光源
      loading: false
    }
  },
  props: {
    id: {
      type: Number,
      default: null
    },
    parkCode: {
      type: String,
      default: null
    }
  },
  methods: {
    // 初始化
    init () {
      let url = `${process.env.VUE_APP_GITF_URL || ''}/gltf`
      let GLTFList = {
        // 后续需要根据建模大小 调整尺寸
        /**
         * x: 决定左右水平方向角度 负数为左 数值越大 旋转越大
         * y: 决定上下垂直方向角度 负数为下
         * z: 个人理解 z角度 会影响相机视角 近而影响 x展示 及 缩放比例
         * top: 模型定位 注意：不同与浏览器定位 浏览器已左上角为起点定位 three 以左下角为起点
         * left: 模型定位
         * zoom: 模型缩放比例
         */
        'BP101029': {
          id: 'BP101029',
          url: `${url}/珍宝公寓.gltf`,
          name: '珍宝公寓',
          x: 0,
          y: 25,
          z: -60,
          top: -10,
          left: 10,
          zoom: 1,
          child: [
            { url: `${url}/珍宝公寓周边路名.gltf` }
          ]
        },
        'BP100954': {
          id: 'BP100954',
          url: `${url}/七宝茂星广场.gltf`,
          name: '七宝茂星广场',
          x: -130,
          y: 25,
          z: 50,
          top: -10,
          left: 60,
          zoom: 1.7,
          child: [
            { url: `${url}/七宝广场路名.gltf` }
          ]
        },
        'BP100768': {
          id: 'BP100768',
          url: `${url}/天山星城.gltf`,
          name: '天山星城',
          x: -130,
          y: 25,
          z: 50,
          top: -10,
          left: 60,
          zoom: 1.5,
          child: [
            { url: `${url}/新渔东路（天山星城）周边路名.gltf` }
          ]
        },
        'BP100753': {
          id: 'BP100753',
          url: `${url}/铭晖商务楼.gltf`,
          name: '铭晖商务楼',
          x: -100,
          y: 50,
          z: 60,
          top: -10,
          left: 0,
          zoom: 1.7,
          child: [
            { url: `${url}/铭晖商务楼周边路名.gltf` }
          ]
        },
        'BP1494': {
          id: 'BP1494',
          url: `${url}/鑫达科研楼.gltf`,
          name: '鑫达科研楼',
          x: 0,
          y: 30,
          z: -100,
          top: -10,
          left: 0,
          zoom: 1.2,
          child: [
            { url: `${url}/科研楼路名.gltf` }
          ]
        },
        'BP1492': {
          id: 'BP1492',
          url: `${url}/剑河路500号.gltf`,
          name: '剑河路500号',
          x: 0,
          y: 50,
          z: 100,
          top: -10,
          left: -20,
          zoom: 1.5
        },
        'PA2022091508423011': {
          id: 'PA2022091508423011',
          url: `${url}/虹桥国际科技广场D栋.gltf`,
          name: '虹桥国际科技广场',
          x: 0,
          y: 40,
          z: -100,
          top: -10,
          left: 10,
          zoom: 1.2,
          child: [
            { url: `${url}/虹桥国际周边路名.gltf` }
          ]
        },
        'PA2022091508461635': {
          id: 'PA2022091508461635',
          url: `${url}/鑫达广场AB栋.gltf`,
          name: '鑫达广场',
          x: 10,
          y: 30,
          z: -140,
          top: -10,
          left: 10,
          zoom: 1.1,
          child: [
            { url: `${url}/鑫达广场路名.gltf` }
          ]
        },
        'BP100690': {
          id: 'BP100690',
          url: `${url}/海盈商务楼.gltf`,
          name: '海盈商务楼',
          x: 100,
          y: 30,
          z: 100,
          top: -10,
          left: 10,
          zoom: 2,
          child: [
            {
              url: `${url}/海盈路名.gltf`
            }
          ]
        },
        'PA2022090615574255': {
          id: 'PA2022090615574255',
          url: `${url}/虹桥中央大厦.gltf`,
          name: '虹桥中央大厦',
          x: 80,
          y: 50,
          z: -100,
          top: -10,
          left: -10,
          zoom: 2
        },
        'PARK202208171427055364271': {
          id: 'PARK202208171427055364271',
          url: `${url}/可乐路.gltf`,
          name: '可乐路',
          x: 0,
          y: 40,
          z: 80,
          top: -5,
          left: 0,
          zoom: 1.5,
          child: [
            { url: `${url}/可乐路路名.gltf` }
          ]
        },
        'BP1055': {
          id: 'BP1055',
          url: `${url}/鑫达大厦.gltf`,
          name: '鑫达大厦',
          x: -100,
          y: 50,
          z: -100,
          top: -5,
          left: -10,
          zoom: 1.9,
          child: [
            { url: `${url}/鑫达大厦周边路名.gltf` }
          ]
        },
        'BP1053': {
          id: 'BP1053',
          url: `${url}/鑫达财富中心.gltf`,
          name: '鑫达财富中心',
          x: -90,
          y: 40,
          z: 70,
          top: -5,
          left: 10,
          zoom: 1.7,
          child: [
            { url: `${url}/财富中心周边路名.gltf` }
          ]
        },
        'BP1052': {
          id: 'BP1052',
          url: `${url}/新泾事务受理中心.gltf`,
          name: '新泾事务受理中心',
          x: 90,
          y: 40,
          z: 0,
          top: -5,
          left: 10,
          zoom: 1.9,
          child: [
            { url: `${url}/新泾镇事务受理中心周边路名.gltf` }
          ]
        },
        // 3: {
        //   id: 3,
        //   url: `${url}/天涯商务楼.gltf`,
        //   name: "天涯商务楼",
        //   x: 120,
        //   y: 70,
        //   z: -100,
        //   top: 5,
        //   left: 30,
        //   zoom: 1.1
        // },
        'PARK202208171422295058072': {
          id: 'PARK202208171422295058072',
          url: `${url}/天涯商务楼.gltf`,
          name: '同仁医院善鑫老年服务公司',
          x: 180,
          y: 50,
          z: -30,
          coreX: 60,
          coreY: 0,
          coreZ: -35,
          top: -5,
          left: 40,
          zoom: 1.5
        },
        'BP1054': {
          id: 'BP1054',
          url: `${url}/鑫达产业园区.gltf`,
          name: '鑫达产业园区',
          x: 10,
          y: 30,
          z: -100,
          top: -10,
          left: 0,
          zoom: 1.6,
          child: [
            { url: `${url}/鑫达产业园区.gltf` }
          ]
        },
        'PA2022091611021337': {
          id: 'PA2022091611021337',
          url: `${url}/海益商务大厦.gltf`,
          name: '海益商务大厦',
          x: -60,
          y: 40,
          z: 110,
          top: -20,
          left: 0,
          zoom: 1.3,
          child: [
            { url: `${url}/海益商务大厦周边路名.gltf` }
          ]
        }
      }
      console.log(this.parkCode)
      let GLTFJson = GLTFList[this.parkCode || 'PARK202208171422295058072']
      console.log(GLTFJson, 'GLTFJson')
      if (!GLTFJson) return
      this.loading = true
      // 创建场景对象
      this.container = this.$refs.scene
      this.scene = new THREE.Scene()
      this.createCamera(GLTFJson.x, GLTFJson.y, GLTFJson.z, GLTFJson.zoom)
      this.createRenderer()
      this.createPoint()
      this.createControls(GLTFJson.coreX, GLTFJson.coreY, GLTFJson.coreZ)
      this.loadModel(GLTFJson.url, GLTFJson.top, GLTFJson.left, GLTFJson.id)
      if (GLTFJson.child) {
        this.loadChildModel(GLTFJson.child, GLTFJson.top, GLTFJson.left, GLTFJson.id)
      }
      this.renderer.setAnimationLoop(() => {
        this.update()
        this.render()
      })
    },
    // 创建相机
    createCamera(x = -80, y = 30, z = 100, zoom = 1.6) {
      // 正交摄像机
      // var width = this.$refs.scene.clientWidth // 窗口宽度
      // var height = this.$refs.scene.clientHeight // 窗口高度
      // var k = width / height // 窗口宽高比
      // var s = 40 // 三维场景显示范围控制系数，系数越大，显示的范围越大
      // this.camera = new THREE.OrthographicCamera(-s * k, s * k, s, -s, -50, 100)
      // this.camera.position.set(0, 40, 80)
      // this.camera.lookAt(this.scene.position) // 设置相机方向(指向的场景对象)
      // 透视相机
      const fov = 45;
      const aspect = 1.75; // the canvas default
      const near = 1;
      const far = 10000;
      this.camera = new THREE.PerspectiveCamera(fov, aspect, near, far);
      this.camera.position.set(x, y, z);
      this.camera.zoom = zoom
      this.camera.up.x = 0; // 相机以哪个方向为上方
      this.camera.up.y = 1;
      this.camera.up.z = 0;
      // 设置了 createControls 故 lookAt 无效
      this.camera.lookAt({ // 相机看向哪个坐标
          x: 0,
          y: 0,
          z: 0
      });
      this.camera.updateProjectionMatrix()
    },
    // 创建光源
    createPoint() {
      // this.point = new THREE.PointLight(0xffffff)
      // this.point.position.set(-100, -100, 100000) // 点光源位置
      // this.scene.add(this.point) // 点光源添加到场景中
      // let ambient = new THREE.AmbientLight(0xFFFFFF, 1.5);
      // this.scene.add(ambient);
    },
    createControls(x = 0, y = 0, z = 0) {
      this.controls = new OrbitControls(this.camera, this.container)
      this.controls.enableZoom = true
      this.controls.minDistance = 5
      this.controls.maxDistance = 250
      this.controls.enablePan = false
      this.controls.enableDamping = true
      this.controls.dampingFactor = 0.35
      // 设置中心位置
      this.controls.target = new THREE.Vector3(x, y, z)
      // 规定垂直方向可旋转范围
      this.controls.minPolarAngle = 0 * Math.PI
      this.controls.maxPolarAngle = 0.5 * Math.PI
      // 规定水平方向可旋转范围
      // this.controls.maxAzimuthAngle = 0 * Math.PI
      // this.controls.minAzimuthAngle = 0.5 * Math.PI
      // 是否开启自动旋转
      // this.controls.autoRotate = true
      // 自动旋转速度
      // this.controls.autoRotateSpeed = 2
    },
    // 创建渲染画布
    createRenderer() {
      this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true })
      this.renderer.setClearColor('#7BA9C8') // 设置背景颜色
      this.renderer.setSize(this.$refs.scene.clientWidth, this.$refs.scene.clientHeight)
      this.renderer.setPixelRatio(window.devicePixelRatio)
      this.renderer.autoClear = false
      this.renderer.outputEncoding = THREE.sRGBEncoding;
      this.container.appendChild(this.renderer.domElement)
    },
    // 导入GLTF
    async loadModel(url, top, left, id, endLoading = true) {
      const res = await get(url)
      url = window.URL.createObjectURL(res)
      const loader = new GLTFLoader()
      loader.load(
        url,
        (gltf) => {
          gltf.scene.traverse(function (child) {
            if (child.isMesh) {
              child.material.emissive = child.material.color
              child.material.emissiveMap = child.material.map
            }
          })
          gltf.scene.position.set(left, top, 0)
          if (id === this.parkCode) {
            this.loading = endLoading ? false : this.loading
            this.scene.add(gltf.scene)
          }
        },
        (xhr) => {
          console.log(`${(xhr.loaded / xhr.total) * 100}% loaded`)
        },
        (error) => {
          console.error("An error happened", error)
        }
      )
    },
    loadChildModel (child, top, left, id) {
      child.forEach(item => {
        this.loadModel(item.url, top, left, id, false)
      })
    },
    update() {
      this.controls.update()
    },
    render() {
      this.renderer.render(this.scene, this.camera)
    },
  },
  mounted () {
    initDataBase()
  },
  watch: {
    id: {
      handler () {
        // 销毁上次渲染
        if (this.scene) {
          this.loading = true
          this.scene.traverse((child) => {
            if (child.material) {
              child.material.dispose();
            }
            if (child.geometry) {
              child.geometry.dispose();
            }
            child = null;
          })
          this.renderer.forceContextLoss()
          this.renderer.dispose()
          this.controls = null
          if (this.$refs.scene.firstElementChild) {
            this.$refs.scene.removeChild(this.$refs.scene.firstElementChild)
          }
        }
        this.init()
      }
    }
  }
  // mounted() {
  //   this.init()
  // }
}
</script>

<style lang="scss" scoped>
.gltf-row {
  position: relative;
  height: 100%;
  width: 1528px;
  padding: 25px 20px;
  // margin-top: 60px;
  background: url("~@/assets/images/bigScreenPage/bg-kuang.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
</style>